import { createBrowserClient } from "@cieda/db";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "https://placeholder.supabase.co";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "placeholder";

export const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey);
